module.exports = __webpack_public_path__ + "static/media/penguincube.1c390480.png";